(function(ns) {
	"use strict";

	var util = ns.util;

	var rules = {
		name: ["notEmpty", "maxLength:200"],
		kana: ["notEmpty", "kana", "maxLength:200"],
		postal_code: ["notEmpty", "postalJP"],
		prefecture: ["notEmpty", "maxLength:4"],
		city: ["notEmpty", "maxLength:200"],
		address: ["notEmpty", "maxLength:200"],
		address2: ["maxLength:200"],
		lat: ["latitude"],
		lng: ["longitude"],
		tel: ["notEmpty", "phoneJPFormat", "phoneJPLength"],
		fax: ["phoneJPFormat", "phoneJPLength"],
		website: ["url", "maxLength:250"],
		public_email: ["email"],
		open: ["maxLength:100"],
		closed: ["maxLength:100"],
		categories: ["array_some"],
		category_other: ["maxLength:50"],
		benefits: ["notEmpty", "maxLength:300"],
		description: ["notEmpty", "maxLength:300"],
		trial_coupon_benefits: ["notEmptyBy:trial_coupon_enabled","maxLength:300"],
	};

	util.component("shop-view", {
		data: function() {
			return {
				apis: ns.store.apis,
				state: ns.store.state,
				entry: ns.store.entry,
				shops_error_: [],
			};
		},
		mounted: function() {
			this.initZZLInputImage();
		},
		computed: {
			// entry.shops に対して shops_error_ の要素が少ない場合でも、
			// entry.shops に存在する添字で shops_error_ にアクセスするための配列を返す。
			// 返された配列は変更不可能（禁止）。
			shops_error: function() {
				var items = [];
				this.shops_error_.forEach(function(item) {
					items.push(item);
				});
				while (items.length < this.entry.shops.length) {
					items.push({});
				}
				return items;
			},
		},
		methods: {
			complete: function() {
				var me = this, errorCount = 0;
				Vue.set(me, "shops_error_", []);
				me.entry.shops.forEach(function(shop, index) {
					var errors = {};
					errorCount += util.validate(shop, rules, errors);
					me.shops_error_.push(errors);
				});
				if (errorCount === 0) {
					me.$emit("viewdidcomplete", "shop");
				} else {
					console.warn("エラーがあります", JSON.stringify(me.shops_error_));
					// 描画更新後に実行
					setTimeout(function() {
						var invalidInput = me.$el.querySelector(".is-invalid");
						if (!invalidInput) return;
						BS.Scroll.toElement(invalidInput.parentNode, 60);
					});
				}
			},
			addShop: function() {
				var me = this;

				me.entry.shops.push(ns.store.initShopData());
				me.shops_error_.push({});

				setTimeout(function() {
					me.initZZLInputImage();
				});
			},
			duplicateShop: function() {
				var me = this;

				var newShop = JSON.parse(JSON.stringify(me.entry.shops[me.entry.shops.length - 1]));
				newShop.name += "（コピー）";

				me.entry.shops.push(newShop);
				me.shops_error_.push({});

				setTimeout(function() {
					me.initZZLInputImage();
				});
			},
			deleteShop: function() {
				this.entry.shops.pop();
				this.shops_error_.pop();
			},
			confirmDeleteShop: function() {
				if (confirm("店舗を削除してもよろしいですか？")) {
					this.deleteShop();
				}
			},
			fillPostalCode: function(index, event) {
				var me = this, entry = me.entry.shops[index];
				if (!entry) return;
				var postalCode = ns.validator.postalJP(entry.postal_code);
				if (!postalCode || !YubinBango) {
					return;
				}
				new YubinBango.Core(postalCode, function(result) {
					if (!result.region) {
						// console.log(result);
						return;
					}
					entry.prefecture = result.region;
					entry.city = result.locality;
					entry.address = result.street + result.extended;
					me.$forceUpdate();

					var addressE = event.target.closest(".h-adr");
					if (!addressE) return;
					var streetE = addressE.querySelector(".p-street");
					if (!streetE) return;
					streetE.focus();
				});
			},
			copyCompanyToShop: function(shop) {
				var entry = this.entry;
				var fields = {
					postal_code: "postal_code",
					prefecture: "prefecture",
					city: "city",
					address: "address",
					address2: "address2",
					tel: "tel",
					fax: "fax",
					website: "website",
					public_email: "public_email",
				};
				Object.keys(fields).forEach(function(fromField) {
					var toField = fields[fromField];
					Vue.set(shop, toField, entry[fromField]);
				});
			},
			positionupdate: function(shop, latlng) {
				["lat", "lng"].forEach(function(field) {
					Vue.set(shop, field, latlng[field]);
				});
			},
			/**
			 * 婚パスの特典内容をお試しクーポンの特典内容にコピーする
			 */
			copyBenefits: function(index) {
				const shop = this.entry.shops[index];
				const src = shop.benefits || '';
				const cur = shop.trial_coupon_benefits || '';

				if (cur !== '' && cur !== src) {
					if (confirm('現在入力されている内容を上書きしてもよろしいですか？')) {
						Vue.set(this.entry.shops[index], "trial_coupon_benefits", src);
					}
				} else {
					Vue.set(this.entry.shops[index], "trial_coupon_benefits", src);
				}
			},
			initZZLInputImage: function() {
				var me = this;
				zzl.qs(".zzl-input-image.not-ready", me.$el).forEach(function(el) {
					$(el).removeClass("not-ready");

					var index = parseInt($(el).attr("data-index"), 10);
					if (isNaN(index)) return;

					new zzl.uploader.ImageUploader(el);

					$(el).on(zzl.uploader.event.uploadComplete, function() {
						me.setImage(index, $(el).find("input[type='hidden']").val());
					}).on(zzl.uploader.event.clear, function() {
						me.setImage(index, null);
					});
				});
			},
			setImage: function(index, uid) {
				Vue.set(this.entry.shops[index], "image", uid);
			},
		},
	});

})(CE);
